import { LegendItem } from '../types/statistics.types';
import LineChartLegendItem from './line-chart.legend-item';
import './line-chart.legend.scss';

interface LineChartLegendProps {
    items: LegendItem[];
    setItems: (data: LegendItem[]) => void;
}

const LineChartLegend: React.FC<LineChartLegendProps> = ({ items, setItems }) => {

       const selectItem = (label: string) => {
        const updatedItems = items.map(item =>
            item.label === label ? { ...item, selected: !item.selected } : item
        );
        setItems(updatedItems);
    };

    return (
        <div className="line-chart-legend width-100 flex-row flex-gap-10 flex-align-end-end flex-wrap">
            {
                items.map((item) => {
                    return (
                        <div key={item.label} style={{cursor: 'pointer'}} onClick={() => selectItem(item.label)}>
                            <LineChartLegendItem item={item} />
                        </div>
                    )
                })
            }
        </div>
    )
}

export default LineChartLegend